type ConsoleMethod = (...args: unknown[]) => void;

export interface ConsoleTarget {
	log: ConsoleMethod;
	info: ConsoleMethod;
	warn: ConsoleMethod;
	error: ConsoleMethod;
	debug: ConsoleMethod;
}

const installed = new WeakSet<object>();
const CODE = /^[A-Z][A-Z0-9_]{2,63}$/;
const UNCLASSIFIED_EVENT = 'UNCLASSIFIED_EVENT';
const SAFE_FIELDS = new Set(['count', 'status', 'status_code', 'duration_ms', 'retry_count']);

function safeFields(value: unknown): Record<string, number | boolean> | undefined {
	if (!value || typeof value !== 'object') return undefined;
	const safe: Record<string, number | boolean> = {};
	for (const [key, item] of Object.entries(value)) {
		if (!SAFE_FIELDS.has(key)) continue;
		if (typeof item === 'boolean' || (typeof item === 'number' && Number.isFinite(item))) {
			safe[key] = item;
		}
	}
	return Object.keys(safe).length > 0 ? safe : undefined;
}

export function installConsoleBoundary(target: ConsoleTarget = console): void {
	if (installed.has(target)) return;
	installed.add(target);
	for (const method of ['log', 'info', 'warn', 'error', 'debug'] as const) {
		const emit = target[method].bind(target);
		target[method] = (code: unknown, fields?: unknown) => {
			if (typeof code !== 'string' || !CODE.test(code)) {
				emit(UNCLASSIFIED_EVENT);
				return;
			}
			const safe = safeFields(fields);
			if (safe) emit(code, safe);
			else emit(code);
		};
	}
}
